module.exports = __webpack_public_path__ + "static/media/icon_photo.12bad756.svg";